interface TrashIconProps {
  className?: string
}

export const TrashIcon = ({ className }: TrashIconProps) => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.83301 15.5C2.37467 15.5 1.98231 15.3368 1.65592 15.0104C1.32954 14.684 1.16634 14.2917 1.16634 13.8333V3H0.333008V1.33333H4.49967V0.5H9.49967V1.33333H13.6663V3H12.833V13.8333C12.833 14.2917 12.6698 14.684 12.3434 15.0104C12.017 15.3368 11.6247 15.5 11.1663 15.5H2.83301ZM11.1663 3H2.83301V13.8333H11.1663V3ZM4.49967 12.1667H6.16634V4.66667H4.49967V12.1667ZM7.83301 12.1667H9.49967V4.66667H7.83301V12.1667Z"
        fill="currentColor"
      />
    </svg>
  )
}
